import app from '../app';
import Modal from '../../common/components/Modal';
import Button from '../../common/components/Button';
import Stream from '../../common/utils/Stream';

export default class GiftPackModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    this.name = vnode.attrs.name;
    this.price = vnode.attrs.price;
    this.desc = vnode.attrs.desc;
    // 图标
    this.icon = vnode.attrs.icon;
    this.reward = vnode.attrs.reward;
    if(this.desc == null || this.desc  == "") {
      // 如果游戏端传过来的说明是空的 就自己拼接奖励
      this.desc = this.reward.map((item, index) => (
        (index != 0 ? "," : "") +item[3] +"*" + item[1]
      ))
    }
    this.originalPrice = vnode.attrs.originalPrice;
  }

  className() {
    return 'NickameModal Modal--small dl-modal-small gift-pack';
  }

  title() {
    return;
  }

  content() {
    return (
      <div className="gift-pack-modal">
        <div className="gift-pack-title">{this.name}</div>
        <div className="gift-pack-content">
          <div className="gift-pack-img">
            <img className="gift-pack-icon" src={this.icon}></img>
            <div className="gift-pack-describe">
              {/* {this.reward.map((item, index) => (
                    <div className='gift-pack-describe-item'>
                      {index !== 0 && <span className="jia">+</span>}
                      <img src={`${app.data.pkgLogo.cdnUrl}/mall/zhoushu2dz1/icon/item/${item[2]}.png`} alt="" />
                      <span>{item[1]}</span>
                    </div>
                  ))} */}
              {this.name}
            </div>
          </div>
          <div className="gift-pack-content-title">{app.translator.trans('dl-pay.forum.gift.gift_package_content')}:</div>
          <div className="gift-pack-content-text">{this.desc}</div>
        </div>
        <div className="gift-pack-price">
          <div
            className="btn"
            onclick={() => {
              this.onClickCommodityBtn();
            }}
          >
            <div className="current-price">USD {this.price}</div>
            <div className="original-price">USD {this.originalPrice}</div>
          </div>
        </div>
      </div>
    );
  }
  onClickCommodityBtn() {
    this.hide();
    let targetElement = document.getElementById('gift-pack-sum');
    // 使用scrollIntoView方法平滑滚动到目标元素
    setTimeout(()=>{
      targetElement.scrollIntoView({ behavior: 'smooth' });
    },500)
  }
}
